import React from "react";
import { actions } from "./../store/Insurance";
import { ApplicationState } from "./../store";
import { connect, ConnectedProps } from "react-redux";
import DropdownSelectorBase from "./DropdownSelectorBase";

const InsuranceReceiveTypeSelector: React.FC<InsuranceReceiveTypeProps> = (props: InsuranceReceiveTypeProps) => {
  if (!props?.values || props.values.length === 0) {
    return <React.Fragment />;
  }

  return (
    <DropdownSelectorBase
      label={{ title: props.label?.title, id: "insuranceReceive" }}
      help={props.help}
      selected={props.selectedValue}
      onChange={props.typeChanged}
      values={props.values?.map(i => ({
        value: i.Code,
        title: i.Name,
      }))}
    />
  );
};

const connector = connect((state: ApplicationState) => state.insurance?.insuranceReceive ?? {}, {
  typeChanged: actions.insuranceReceiveTypeChanged,
});

type InsuranceReceiveTypeProps = ConnectedProps<typeof connector> & {};

export default connector(InsuranceReceiveTypeSelector);
